import type { ForManagerLocationDetail } from "@sidegigllc/api/client";
import { queries as reportBuilderQueries } from "domains/dashboards/containers/ReportBuilder/queries";
import type { WarmableQuery } from "routing/warmQueries";

export const queries = (input: { location: ForManagerLocationDetail; runId?: string }): Array<WarmableQuery> =>
  reportBuilderQueries(input);
